import * as types from './types';
import api from '~/services/api';


export const searchEditHistory = ({ historyId, tableName }) => async (dispatch) => {
  const { data: { result: payload } } = await api.get(
    '/logs/edit_logs',
    {
      params: {
        pk_value: historyId,
        table_name: tableName,
      },
    },
  );
  dispatch({ type: types.SEARCH_EDIT_HISTORY, payload });
};
